import React, { useId } from 'react';
import { Dialog } from '@mui/material';
import { MERCURY_ASSISTANT_TENANT } from '../features/financialReportAssistant';
import { FinancialAssistantFlow } from './FinancialReportAssistant';

export default function FinancialPromptReportDialog(props) {
  const id = useId();
  if (!props.enabled || props.tenantId !== MERCURY_ASSISTANT_TENANT || props.capabilities?.canRead !== true) return null;
  return <Dialog open={Boolean(props.open)} onClose={props.onClose} fullWidth maxWidth="md" className="financial-assistant-modal fra-prompt-dialog" aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`} PaperProps={{ className: 'fra-dialog-paper' }}><FinancialAssistantFlow key={JSON.stringify([props.tenantId, props.companyId, props.requesterId, props.report?.id, props.report?.version])} {...props} kind="draft" titleId={`${id}-title`} descriptionId={`${id}-description`} /></Dialog>;
}
